import { createBrowserRouter, Link } from 'react-router';

import { SignInPage } from '@/features/auth/SignInPage';
import { CompaniesPage } from '@/features/companies/CompaniesPage';
import { CompanyDetailPage } from '@/features/companies/CompanyDetailPage';
import { NewCompanyPage } from '@/features/companies/NewCompanyPage';

import { AuthGuard, Shell } from './Shell';

function NotFound() {
  return (
    <div className="p-7 text-center text-ink3">
      <h1 className="font-cond text-xl font-extrabold text-ink">Page not found</h1>
      <p className="mt-2">
        <Link to="/" className="font-semibold text-orange-ink underline">
          Back to companies
        </Link>
      </p>
    </div>
  );
}

export const router = createBrowserRouter([
  { path: '/sign-in', element: <SignInPage /> },
  {
    element: <AuthGuard />,
    children: [
      {
        element: <Shell />,
        children: [
          { path: '/', element: <CompaniesPage /> },
          { path: '/companies/new', element: <NewCompanyPage /> },
          { path: '/companies/:id', element: <CompanyDetailPage /> },
          { path: '*', element: <NotFound /> },
        ],
      },
    ],
  },
]);
